import React, { Component } from "react";
import { Link } from "react-router-dom";
import DataTable from "react-data-table-component";
import Constant from "../../Constant";
import BarLoader from "react-bar-loader";

import ImagesUploader from "react-images-uploader";

export default class ActivityLogs extends Component {
  state = {
    loading: true,
    data: [],
    columns: [
      {
        name: "Event Name",
        selector: "eventName",
        sortable: true,
      },
      {
        name: "Created At",
        selector: "createdAt",
        sortable: true,
      },
    ],
  };
  componentDidMount() {
    this.getUserActivityLogs();
  }
  getUserActivityLogs = () => {
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/x-www-form-urlencoded");
    myHeaders.append(
      "Authorization",
      localStorage.getItem("livelms_auth")
    );

    var urlencoded = new URLSearchParams();
    urlencoded.append("userId", localStorage.getItem("lms_uid"));

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: urlencoded,
      redirect: "follow",
    };

    fetch(Constant.getSiteAPI() + "/user/timeline", requestOptions)
      .then((response) => response.json())
      .then((result) => {
        var data = result.result;
        for (let i = 0; i < data.length; i++) {
          console.log(data[i]);
          var str = data[i].createdAt;
          var date = new Date(str);
          data[i].fullName = data[i].firstName + " " + data[i].lastName;
          console.log(data[i]);
          data[i].createdAt = `${date.getUTCDate()}-${
            date.getUTCMonth() + 1
            }-${date.getUTCFullYear()}`;
          data[i].updatedAt = `${date.getUTCDate()}-${
            date.getUTCMonth() + 1
            }-${date.getUTCFullYear()}`;
        }
        this.setState({ data: data, loading: false });
      })
      .catch((error) => console.log("error", error));
  };

  render() {
    return (
      <div>
        <div className="py-3">
          <div className="container border shadow-sm p-0 bg-white">
            <div className="header bg-primary text-white">
              <div className="row m-0">
                <div className="col-md-8 p-3 d-flex align-items-center">
                  <h5 className="m-0">
                    {
                      localStorage.getItem('livelms_role') === 'learner'
                        ?
                        <Link to="/learner/course-list">Home</Link>
                        :
                        localStorage.getItem('livelms_role') === 'trainer'
                          ?
                          <Link to="/trainer/dashboard">Home</Link>
                          :
                          <Link to="/admin/dashboard">Home</Link>
                    }/{" "}
                    {"Activity Logs"}
                  </h5>
                </div>
              </div>
            </div>

            <div className="users-container p-2">
              {this.state.loading == true ? (
                <div className="container p-5">
                  <div className="col-md-3 mx-auto">
                    <BarLoader color="#33cabb" height="4" />
                  </div>
                </div>
              ) : (
                  <DataTable
                    noHeader={true}
                    columns={this.state.columns}
                    data={this.state.data}
                    theme="solarized"
                    pagination={true}
                    noDataComponent={
                      <div className="m-3">No Activity Logs Available</div>
                    }
                  />
                )}
            </div>
          </div>
        </div>
      </div>
    );
  }
}
